import { chakra, Tag, TagCloseButton, TagLabel } from "@chakra-ui/react";
import { forwardRef } from "react";
import { useTranslation } from "react-i18next";

const MIN_TAP_TARGET = "44px";

export const RemovableFilterChip = forwardRef<
  HTMLSpanElement,
  {
    label: string;
    value?: string;
    onRemove: () => void;
    onOpen?: () => void;
    testId?: string;
  }
>(({ label, value, onRemove, onOpen, testId }, ref) => {
  const { t } = useTranslation();
  const name = value === undefined ? label : `${label}: ${value}`;
  const text =
    value === undefined ? (
      label
    ) : (
      <>
        {label}: <chakra.b fontWeight="bold">{value}</chakra.b>
      </>
    );
  return (
    <Tag
      ref={ref}
      size="lg"
      variant="outline"
      bg="smPrimarySofter"
      color="smPrimary"
      boxShadow="none"
      borderWidth="1px"
      borderStyle="solid"
      borderColor="smPrimary"
      borderRadius="full"
      data-testid={testId}
    >
      {onOpen ? (
        <TagLabel
          as="button"
          type="button"
          onClick={onOpen}
          textAlign="left"
          aria-label={String(t("Change the filter «{{filter}}»", { filter: name }))}
        >
          {text}
        </TagLabel>
      ) : (
        <TagLabel>{text}</TagLabel>
      )}
      <TagCloseButton
        aria-label={String(t("Remove the filter «{{filter}}»", { filter: name }))}
        onClick={onRemove}
        position="relative"
        _before={{
          content: '""',
          position: "absolute",
          top: "50%",
          left: "50%",
          w: MIN_TAP_TARGET,
          h: MIN_TAP_TARGET,
          transform: "translate(-50%, -50%)",
        }}
      />
    </Tag>
  );
});

RemovableFilterChip.displayName = "RemovableFilterChip";
